import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=687354e0&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=ts&"
export * from "./Article.vue?vue&type=script&lang=ts&"
import style0 from "./Article.vue?vue&type=style&index=0&id=687354e0&scoped=true&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687354e0",
  null
  
)

export default component.exports